import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'
import { AgentSessionType } from './types'

interface Args {
  organizationUuid: string
  applicationUuid: string
  agentSessionId?: string
  enabled: boolean
}

interface QueryArgs {
  organizationUuid: string
  applicationUuid: string
  agentSessionId?: string
}

interface Response {
  agentSession: AgentSessionType
  messages?: string[]
  success: boolean
  error: boolean
  isLoading: boolean
}

async function query(
  this: ThisConnector,
  { organizationUuid, applicationUuid, agentSessionId }: QueryArgs
) {
  return this.connector
    .get(
      `/organizations/${organizationUuid}/applications/${applicationUuid}/agent-sessions/${agentSessionId}`
    )
    .then((data) => {
      // this works out a lot simpler than trying to track it elsewhere
      // this flag should move to the backend if we need to confront
      // the edge case of loading the most recent session by id only
      // which could be required if we load just by url, in the way
      // the dashboard passes filters
      if (data.agentSession && agentSessionId === 'latest') {
        data.agentSession.isMostRecentSession = true
      }

      return data
    })
}

export const useAgentSessions = ({
  organizationUuid,
  applicationUuid,
  agentSessionId,
  enabled
}: Args) => {
  return useContrastQuery<Args, Response>(
    [
      Query.AGENT_SESSION_BY_ID,
      organizationUuid,
      applicationUuid,
      agentSessionId,
      enabled
    ],
    query,
    {
      organizationUuid,
      applicationUuid,
      agentSessionId,
      enabled
    },
    {
      enabled
    }
  )
}
